var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"types-with-assets":_vm.typesWithAssets}})}
var staticRenderFns = []

export { render, staticRenderFns }